<script lang="ts">
	import BuildYourSubscriptionButton from "@components/BuildYourSubscriptionButton.svelte";
	import Button from "@components/common/Button.svelte";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import { ButtonVariant } from "@components/common/ButtonVariant.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import translations from "./FathersClubSubscriptionTypesSection.translations.json" with { type: "json" };

	const translate = getTranslate(translations);

	const recurringColors = [
		"bg-fcramber",
		"bg-fcrtan",
		"bg-fcrslate",
		"bg-fcrterracotta",
		"bg-fcrbrown",
		"bg-fcrblue",
		"bg-fcrsalmon",
		"bg-fcrlinen",
		"bg-fcrperiwinkle",
	];
</script>

<section class="pb-12 sm:pb-14 md:pb-16 lg:pb-24 xl:pb-32 2xl:pb-40 text-center">
	<div class="py-12 sm:py-14 xl:py-16 px-4">
		<div class="uppercase text-fcrorange font-bold tracking-[.1em] text-sm mb-4">
			<Formatted text={translate("sectionCaption")} />
		</div>
		<Heading
			level={2}
			text={translate("sectionTitle")}
			class="font-antipol font-medium text-8/tighter text-fcrdarkgray"
		/>
	</div>
	<div class="flex flex-col gap-y-8 lg:flex-row">
		<div class="flex-1 flex flex-col">
			<div class="bg-fcrbeige p-8 sm:p-10 xl:p-12 flex flex-col gap-5 flex-1">
				<div class="uppercase text-fcrorange font-bold tracking-[.1em] text-sm">
					<Formatted text={translate("recurringCaption")} />
				</div>
				<Heading
					level={3}
					text={translate("recurringTitle")}
					class="font-antipol font-medium text-7/tighter text-fcrdarkgray"
				/>
				<ul class="list-['✓_'] pl-5 space-y-2 text-fcrgray text-sm/relaxed text-left m-auto font-semibold">
					<li class="pl-1"><Formatted text={translate("recurringFeature1")} /></li>
					<li class="pl-1"><Formatted text={translate("recurringFeature2")} /></li>
					<li class="pl-1"><Formatted text={translate("recurringFeature3")} /></li>
					<li class="pl-1"><Formatted text={translate("recurringFeature4")} /></li>
					<li class="pl-1"><Formatted text={translate("recurringFeature5")} /></li>
					<li class="pl-1"><Formatted text={translate("recurringFeature6")} /></li>
					<li class="pl-1"><Formatted text={translate("recurringFeature7")} /></li>
				</ul>
			</div>
			<div class="relative">
				<div class="grid grid-cols-3">
					{#each recurringColors as color (color)}
						<div class={["h-26", color]}></div>
					{/each}
				</div>
				<div class="absolute inset-0 flex items-center justify-center">
					<BuildYourSubscriptionButton variant={ButtonVariant.White} />
				</div>
			</div>
		</div>
		<div class="flex-1 flex flex-col">
			<div class="bg-fcrlinen p-8 sm:p-10 xl:p-12 flex flex-col gap-5 flex-1">
				<div class="uppercase text-white font-bold tracking-[.1em] text-sm">
					<Formatted text={translate("giftCaption")} />
				</div>
				<Heading
					level={3}
					text={translate("giftTitle")}
					class="font-antipol font-medium text-7/tighter text-fcrdarkgray"
				/>
				<ul class="list-['✓_'] pl-5 space-y-2 text-fcrgray text-sm/relaxed text-left m-auto font-semibold">
					<li class="pl-1"><Formatted text={translate("giftFeature1")} /></li>
					<li class="pl-1"><Formatted text={translate("giftFeature2")} /></li>
					<li class="pl-1"><Formatted text={translate("giftFeature3")} /></li>
					<li class="pl-1"><Formatted text={translate("giftFeature4")} /></li>
					<li class="pl-1"><Formatted text={translate("giftFeature5")} /></li>
				</ul>
			</div>
			<div class="relative">
				<div class="grid grid-cols-3 bg-fcrlinen">
					{#each { length: 9 } as _, index (index)}
						<div class="h-26 bg-fcrgray-400/49 border border-fcrlinen"></div>
					{/each}
				</div>
				<div class="absolute inset-0 flex items-center justify-center">
					<Button disabled title={translate("giftComingSoon")} size={ButtonSize.Medium} variant={ButtonVariant.White}>
						<Formatted text={translate("giftComingSoon")} />
					</Button>
				</div>
			</div>
		</div>
	</div>
</section>
